module.exports = {
      id: "shareblueicon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#shareblueicon",
      toString: function () {
        return this.url;
      }
    }